import React, { lazy } from "react"

import { RouteObject } from "react-router"

const AutomatonsPage = lazy(() => import("./AutomatonsPage"))
export const AutomatonsRoutes: RouteObject[] = [
	{ path: "", element: <AutomatonsPage /> },
]
